import React from 'react'

import styled from 'styled-components'

import FeedbackQuestion from './FeedbackQuestion'
import P from '../../../../../components/typography/P'

const FeedbackQuestions = ({ questions, handleQuestions }) => {
  return (
    <StyledFeedbackQuestions>
      <P weight="500">Please rate the following: </P>

      <div className="question__content">
        <div className="questions__list">
          {questions.map((q) => (
            <>
              <FeedbackQuestion
                handleQuestion={(value) => handleQuestions(q.id, value)}
                key={q.id}
                question={q.question}
                value={q.answer}
              />
            </>
          ))}
        </div>
      </div>
    </StyledFeedbackQuestions>
  )
}

export default FeedbackQuestions

const StyledFeedbackQuestions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;

  .question__content {
    display: flex;
    flex-direction: column;

    .question__header {
      display: flex;
    }

    .questions__list {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
  }
`
